/**
 * Function to download a file from the express server.
 * @param {Response} res - Express response object
 * @returns {Promise<Response>} - Promise that resolves with the response object
 *  for the further processing in the chain.
 */
export default async (res: Response): Promise<Response> => {
  // get the filename from the response headers
  // "content-disposition: attachment; filename=filename.ext"
  const header = res.headers.get('Content-Disposition');
  const parts = header!.split(';');
  let filename = parts[1].split('=')[1];

  // remove surrounding quotes from the filename if present
  if (filename.charAt(0) === '"' && filename.charAt(filename.length - 1) === '"') {
    filename = filename.substring(1, filename.length - 1);
  }

  // get the Buffer from the response body and create a blob
  const blob = await res.blob();

  // create a blob URL from the blob
  const url = window.URL.createObjectURL(blob);

  // create a link element to download the file
  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('download', filename);
  a.setAttribute('target', '_blank');

  // append the link to the document and click it
  document.body.appendChild(a);
  a.click();

  // remove the link from the document and clean up
  a.remove();
  window.URL.revokeObjectURL(url);

  // return the response object to the caller for further processing
  return res;
};
